// extracted by mini-css-extract-plugin
module.exports = {"Background":"Background_Background__2mb4p"};